<template>
  <v-card height="100%">
    <v-layout column fill-height>
      <v-flex shrink style="margin: 4px 20px">
        <v-btn icon small class="ma-0" @click="returnToToolbar">
          <v-icon style="font-size: 10px">arrow_back_ios</v-icon>
        </v-btn>
        <span style="text-transform: uppercase">{{ title }}...</span>
      </v-flex>
      <slot />
    </v-layout>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "MaskSideSectionContainer",

  props: {
    title: {
      type: String,
      required: true
    }
  },

  computed: {
    activeSideSection() {
      return this.$store.getters.getMasksTabSideSection;
    }
  },

  methods: {
    ...mapActions(["setSelectedDuctEntryIndex", "setMasksTabSideSection"]),

    returnToToolbar() {
      this.setSelectedDuctEntryIndex(undefined);
      this.setMasksTabSideSection("toolbar");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Masks/Masks/MaskSideSectionContainer.vue